import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect, useRef } from "react";
import routes from "./config";

let navigateResolver: (navigate: NavigateFunction) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: NavigateFunction;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  const navigateRef = useRef(navigate);
  const isInitialized = useRef(false);
  
  // Update ref when navigate changes
  useEffect(() => {
    navigateRef.current = navigate;
  }, [navigate]);
  
  // Initialize only once
  useEffect(() => {
    if (!isInitialized.current) {
      isInitialized.current = true;
      window.REACT_APP_NAVIGATE = navigateRef.current;
      navigateResolver(navigateRef.current);
    }
  }, []);
  
  return element;
}
